<template>
  <div style="height: 100%">
    <div class="actionBtn">
      <el-button type="primary" @click="productGroupGo(0)"
        ><el-icon> <plus /> </el-icon><span>新增分组</span></el-button
      >
    </div>
    <el-dialog v-model="dialogFormVisible" :title="title">
      <el-form :model="formState" :rules="rules">
        <el-form-item
          label="分类归属："
          :label-width="formLabelWidth"
          prop="pdt_group_pid"
        >
          <el-select
            v-model="formState.pdt_group_pid"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in getFatherProductGroupList"
              :key="item.pdt_group_id"
              :label="item.pdt_group_name_ch"
              :value="item.pdt_group_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="负责人："
          :label-width="formLabelWidth"
          prop="user_id"
        >
          <el-select v-model="formState.user_id" :popper-append-to-body="false">
            <el-option
              v-for="item in getUserList"
              :key="item.user_id"
              :label="item.user_name_ch"
              :value="item.user_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="分类中文名："
          :label-width="formLabelWidth"
          prop="pdt_group_name_ch"
        >
          <el-input
            v-model="formState.pdt_group_name_ch"
            placeholder="输入分类名称："
            clearable
          />
        </el-form-item>
        <el-form-item label="分类英文名：" :label-width="formLabelWidth">
          <el-input
            v-model="formState.pdt_group_name_en"
            placeholder="输入分类名称："
            clearable
          />
        </el-form-item>
        <el-form-item
          label="分类简码："
          :label-width="formLabelWidth"
          prop="pdt_group_code"
        >
          <el-input
            maxlength="3"
            show-word-limit
            v-model="formState.pdt_group_code"
            placeholder="输入分类简码："
            clearable
          />
        </el-form-item>
        <el-form-item label="分类图片：" :label-width="formLabelWidth">
          <el-input v-model="formState.pdt_group_pic" clearable />
        </el-form-item>
        <el-form-item label="分类排序：" :label-width="formLabelWidth">
          <el-input
            v-model="formState.pdt_group_sort"
            placeholder="输入分类排序0-9999"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态：" :label-width="formLabelWidth">
          <el-switch
            v-model="formState.pdt_group_status"
            class="ml-2"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="add">{{ goTitle }}</el-button>
        </span>
      </template>
    </el-dialog>
    <div class="content">
      <el-table
        :data="dataSource"
        style="width: 100%; font-size: 12px"
        row-key="pdt_group_id"
      >
        <el-table-column fixed prop="pdt_group_id" label="ID" width="100" />
        <el-table-column
          prop="pdt_group_name_ch"
          label="中文名"
          width="150"
          fixed
        />
        <el-table-column prop="pdt_group_name_en" label="英文名" width="150" />
        <el-table-column prop="pdt_group_code" label="分类简码" width="200" />
        <el-table-column prop="user_id_v" label="负责人" width="200" />
        <el-table-column prop="pdt_group_status" label="状态" width="120">
          <template #default="scope">
            <span
              :style="{
                color: scope.row.pdt_group_status == 1 ? 'green' : 'red',
              }"
            >
              {{ scope.row.pdt_group_status == 1 ? "开启" : "关闭" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="pdt_group_remark" label="备注" width="150" />
        <el-table-column fixed="right" label="操作" width="200">
          <template #default="scope">
            <el-button type="primary" @click="productGroupGo(scope.row)">
              <el-icon> <edit /> </el-icon><span>编辑</span></el-button
            >
            <el-button type="danger" @click="del(scope.row.pdt_group_id)"
              ><el-icon> <delete /> </el-icon><span>删除</span></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="demo-pagination-block">
        <el-pagination
          :currentPage="currentPage"
          :page-size="pageSize"
          :page-sizes="[20, 50, 100]"
          :background="true"
          layout="sizes, prev, pager, next, jumper,total"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import {
  productGroupList,
  productGroupAdd,
  productGroupDel,
  getFatherProductGroupList,
} from "@/network/product.js";
import { getUserList } from "@/network/user.js";
import { Delete, Edit, Plus } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  components: {
    Delete,
    Edit,
    Plus,
  },
  setup() {
    const currentPage = ref(1);
    const pageSize = ref(10);
    const pageTotal = ref(0);
    const state = reactive({
      dataSource: [],
      title: "添加产品分类",
      goTitle: "添加",
      getUserList: [],
      getFatherProductGroupList: [],
      dialogFormVisible: false,
      formLabelWidth: "140px",
    });
    const rules = reactive({
      user_id: [
        {
          required: true,
          message: "请选择负责人",
          trigger: "change",
        },
      ],
      pdt_group_name_ch: [
        {
          required: true,
          message: "请输入分组中文名",
          trigger: "change",
        },
      ],
      pdt_group_code: [
        {
          required: true,
          message: "请输入产品分类简码:RFD/SHD/NEW",
          trigger: "blur",
        },
      ],
      pdt_group_pid: [
        {
          required: true,
          message: "请选择新增分组的归属",
          trigger: "change",
        },
      ],
    });
    const formState = reactive({
      pdt_group_id: 0,
      pdt_group_pid: 0,
      pdt_group_name_ch: "",
      pdt_group_name_en: "",
      pdt_group_code: "",
      pdt_group_sort: 0,
      user_id: 1,
      pdt_group_pic: "",
      pdt_group_status: true,
      pdt_group_remark: "",
    });
    const getList = () => {
      productGroupList({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        listType: 1,
      }).then((res) => {
        if (res.code == 0) {
          state.dataSource = res.data.lists;
          pageTotal.value = res.data.pageTotal;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleSizeChange = (val) => {
      pageSize.value = val;
      getList();
    };
    const handleCurrentChange = (val) => {
      currentPage.value = val;
      getList();
    };
    onMounted(() => {
      getList();
    });

    //------------以上为列表数据
    const productGroupGo = (row) => {
      state.dialogFormVisible = true;
      //返回用户列表
      getUserList().then((res) => {
        if (res.code == 0) {
          state.getUserList = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
      //返回一级产品分类栏列表
      getFatherProductGroupList().then((res) => {
        if (res.code == 0) {
          state.getFatherProductGroupList = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
      if (row) {
        Object.assign(formState, row);
        state.goTitle = "更新";
        state.title = "修改产品分类信息";
        formState.pdt_group_status = Boolean(row.pdt_group_status);
      } else {
        state.title = "添加产品分类";
        formState.pdt_group_id = 0;
        formState.pdt_group_pid = 0;
        formState.pdt_group_name_en = "";
        formState.pdt_group_name_ch = "";
        formState.pdt_group_code = "";
        formState.pdt_group_sort = 0;
        formState.user_id = 1;
        formState.pdt_group_pic = "";
        formState.pdt_group_status = true;
        formState.pdt_group_remark = "";
      }
    };
    const add = () => {
      //无论新增还是修改，用户名都是必填;
      if (!formState.pdt_group_name_ch) {
        ElMessage.info("请输入产品分类名");
        return false;
      }
      productGroupAdd(formState).then((res) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          state.dialogFormVisible = false;
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    //------------以上为编辑和修改数据
    const del = (pdt_group_id) => {
      if (!pdt_group_id) {
        ElMessage("所选数据为空，请重新选择！");
      } else {
        ElMessageBox.confirm("确定要删除该条数据吗?", "警告", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            productGroupDel({ pdt_group_id: pdt_group_id, del_type: 0 }).then(
              (res) => {
                if (res.code == 0) {
                  ElMessage.success(res.msg);
                  getList();
                } else {
                  ElMessage.error(res.msg);
                }
              }
            );
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "删除取消",
            });
          });
      }
    };
    return {
      ...toRefs(state),
      rules,
      formState,
      productGroupGo,
      add,
      del,
      currentPage,
      pageSize,
      pageTotal,
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>
<style scoped>
.el-select :deep .select-popper {
  z-index: 8888 !important;
  top: auto !important;
  left: auto !important;
}
.actionBtn {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.content {
  height: calc(100% - 180px);
  position: relative;
}
.el-table {
  position: absolute;
}
.el-table__header {
  width: 100%;
}
.el-table__body {
  height: calc(100% - 40px);
}
.el-pagination {
  position: absolute;
  bottom: -56px;
  right: 20px;
}
</style>
